import { PageTemplate } from "../../components"

export const HelpPage = () => {

  return (
    <PageTemplate>
      <h2>Hjelp</h2>
    </PageTemplate>
  )
}